import { RentalActions, RentalActionTypes } from "../actions/rental.action";

export interface RentalState {
  rentals: any[];
  rentalsLoading: boolean;
  rentalsError: boolean;

  rentalSizes: any[];
  rentalSizesLoading: boolean;
  rentalSizesError: boolean;

  rentalPeriods: any[];
  rentalPeriodsLoading: boolean;
  rentalPeriodsError: boolean;

  rentalOptions: any[];
  rentalOptionsLoading: boolean;
  rentalOptionsError: boolean;
  
  rentalCategory: any[];
  rentalCategoryLoading: boolean;
  rentalCategoryError: boolean;
  
  rentalCategorySize: any[];
  rentalCategorySizeLoading: boolean;
  rentalCategorySizeError: boolean;

  createRentalLineItemSuccess: boolean;
  createRentalLineItemLoading: boolean;
  createRentalLineItemError: boolean;
  createdRentalLineItems: any[];

  updateRentalLineItemSuccess: boolean;
  updateRentalLineItemLoading: boolean;
  updateRentalLineItemError: boolean;
  updatedRentalLineItem: any;
}

export const initialState: RentalState = {
  rentals: [],
  rentalsLoading: false,
  rentalsError: false,

  rentalSizes: [],
  rentalSizesLoading: false,
  rentalSizesError: false,

  rentalPeriods: [],
  rentalPeriodsLoading: false,
  rentalPeriodsError: false,

  rentalOptions: [],
  rentalOptionsLoading: false,
  rentalOptionsError: false,
  
  rentalCategory: [],
  rentalCategoryLoading: false,
  rentalCategoryError: false,
  
  rentalCategorySize: [],
  rentalCategorySizeLoading: false,
  rentalCategorySizeError: false,

  createRentalLineItemSuccess: false,
  createRentalLineItemLoading: false,
  createRentalLineItemError: false,
  createdRentalLineItems: [],

  updateRentalLineItemSuccess: false,
  updateRentalLineItemLoading: false,
  updateRentalLineItemError: false,
  updatedRentalLineItem: null
};

export function reducer(
  state = initialState,
  action: RentalActions
): RentalState {
  switch (action.type) {
    case RentalActionTypes.GET_RENTAL_PRICE_LIST: {
      return {
        ...state,
        rentalsLoading: true,
        rentalsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        rentals: action.payload,
        rentalsLoading: false,
        rentalsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PRICE_LIST_FAILURE: {
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: true,
      };
    }
    
    case RentalActionTypes.GET_RENTAL_CATEGORY: {
      return {
        ...state,
        rentalCategoryLoading: true,
        rentalCategoryError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_CATEGORY_SUCCESS: {
      return {
        ...state,
        rentalCategory: action.payload,
        rentalCategoryLoading: false,
        rentalCategoryError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_CATEGORY_FAILURE: {
      return {
        ...state,
        rentalCategoryLoading: false,
        rentalCategoryError: true,
      };
    }
    
    case RentalActionTypes.GET_RENTAL_CATEGORY_SIZE: {
      return {
        ...state,
        rentalCategorySizeLoading: true,
        rentalCategorySizeError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_CATEGORY_SIZE_SUCCESS: {
      return {
        ...state,
        rentalCategorySize: action.payload,
        rentalCategorySizeLoading: false,
        rentalCategorySizeError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_CATEGORY_SIZE_FAILURE: {
      return {
        ...state,
        rentalCategorySizeLoading: false,
        rentalCategorySizeError: true,
      };
    }

    case RentalActionTypes.GET_RENTAL_PRICE: {
      return {
        ...state,
        rentalsLoading: true,
        rentalsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PRICE_SUCCESS: {
      return {
        ...state,
        rentals: action.payload,
        rentalsLoading: false,
        rentalsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PRICE_FAILURE: {
      return {
        ...state,
        rentalsLoading: false,
        rentalsError: true,
      };
    }

    case RentalActionTypes.CLEAR_RENTAL_PRICE_LIST: {
      return {
        ...state,
        rentals: []
      };
    }

    case RentalActionTypes.GET_RENTAL_SIZE: {
      return {
        ...state,
        rentalSizesLoading: true,
        rentalSizesError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_SIZE_SUCCESS: {
      return {
        ...state,
        rentalSizes: action.payload,
        rentalSizesLoading: false,
        rentalSizesError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_SIZE_FAILURE: {
      return {
        ...state,
        rentalSizesLoading: false,
        rentalSizesError: true,
      };
    }

    case RentalActionTypes.CLEAR_RENTAL_SIZE_LIST: {
      return {
        ...state,
        rentalSizes: []
      };
    }

    case RentalActionTypes.GET_RENTAL_PERIOD: {
      return {
        ...state,
        rentalPeriodsLoading: true,
        rentalPeriodsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PERIOD_SUCCESS: {
      return {
        ...state,
        rentalPeriods: action.payload,
        rentalPeriodsLoading: false,
        rentalPeriodsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_PERIOD_FAILURE: {
      return {
        ...state,
        rentalPeriodsLoading: false,
        rentalPeriodsError: true,
      };
    }

    case RentalActionTypes.GET_RENTAL_OPTION: {
      return {
        ...state,
        rentalOptionsLoading: true,
        rentalOptionsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_OPTION_SUCCESS: {
      return {
        ...state,
        rentalOptions: action.payload,
        rentalOptionsLoading: false,
        rentalOptionsError: false,
      };
    }

    case RentalActionTypes.GET_RENTAL_OPTION_FAILURE: {
      return {
        ...state,
        rentalOptionsLoading: false,
        rentalOptionsError: true,
      };
    }

    case RentalActionTypes.CREATE_RENTAL_LINE_ITEM: {
      return {
        ...state,
        createRentalLineItemLoading: true,
        createRentalLineItemError: false,
      };
    }

    case RentalActionTypes.CREATE_RENTAL_LINE_ITEM_SUCCESS: {
      return {
        ...state,
        createdRentalLineItems: [...state.createdRentalLineItems, action.payload],
        createRentalLineItemSuccess: true,
        createRentalLineItemLoading: false,
        createRentalLineItemError: false,
      };
    }

    case RentalActionTypes.CREATE_RENTAL_LINE_ITEM_FAILURE: {
      return {
        ...state,
        createRentalLineItemLoading: false,
        createRentalLineItemError: true,
      };
    }

    case RentalActionTypes.CLEAR_RENTAL_LINE_ITEM: {
      return {
        ...state,
        createdRentalLineItems: [],
        createRentalLineItemSuccess: false,
        createRentalLineItemLoading: false,
        createRentalLineItemError: false,
      };
    }

    case RentalActionTypes.UPDATE_RENTAL_LINE_ITEM: {
      return {
        ...state,
        updateRentalLineItemLoading: true,
        updateRentalLineItemError: false,
      };
    }

    case RentalActionTypes.UPDATE_RENTAL_LINE_ITEM_SUCCESS: {
      return {
        ...state,
        updateRentalLineItemSuccess: true,
        updateRentalLineItemLoading: false,
        updateRentalLineItemError: false,
      };
    }

    case RentalActionTypes.UPDATE_RENTAL_LINE_ITEM_FAILURE: {
      return {
        ...state,
        updateRentalLineItemLoading: false,
        updateRentalLineItemError: true,
      };
    }

    case RentalActionTypes.CLEAR_RENTAL_LINE_ITEM_UPDATE: {
      return {
        ...state,
        updateRentalLineItemLoading: false,
        updateRentalLineItemError: false,
        updateRentalLineItemSuccess: false
      };
    }

    case RentalActionTypes.CLEAR_RENTAL_LINE_ITEM: {
      return {
        ...state,
        updateRentalLineItemSuccess: false,
        updateRentalLineItemLoading: false,
        updateRentalLineItemError: false,
      };
    }

    default:
      return state;
  }
}
